module.exports = __webpack_public_path__ + "img/products-2@2x.3fdfeb5.jpg";